import { render, staticRenderFns } from "./Innovation.vue?vue&type=template&id=e2939436&scoped=true&"
import script from "./Innovation.vue?vue&type=script&lang=js&"
export * from "./Innovation.vue?vue&type=script&lang=js&"
import style0 from "./Innovation.vue?vue&type=style&index=0&id=e2939436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2939436",
  null
  
)

export default component.exports